import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { userActions } from '../../actions';
import { Button, Form, Header, Segment, Transition } from 'semantic-ui-react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const Billing = () => {
  return <div>Billing Setting</div>;
};

export default Billing;
